import { parsePhoneNumberWithError } from 'libphonenumber-js';
import * as React from 'react';

const useFormattedPhone = (phoneNumber: string): string => {
  return React.useMemo(() => {
    try {
      return parsePhoneNumberWithError(phoneNumber).formatNational();
    } catch {
      return phoneNumber;
    }
  }, [phoneNumber]);
};

export default useFormattedPhone;
